import React from 'react';

import { BRAND_LIBRARY_BODY_TEXT } from 'common/constants/brandLibrary';
import Paragraph from 'common/components/TouchpointEditor/components/TouchpointNodes/Paragraph';

export default function CountdownText(props) {
    return <Paragraph {...props} />;
}

CountdownText.splash = {
    ...Paragraph.splash,
    defaultProps: {
        ...Paragraph.splash.defaultProps,
        styles: {
            ...Paragraph.splash.defaultProps.styles,
            fontFamily: BRAND_LIBRARY_BODY_TEXT,
            fontSize: 16,
        },
        meta: {
            ...Paragraph.splash.defaultProps.meta,
            content: 'Starting soon',
        },
    },
};
